import styled from '@emotion/styled/macro';

export const Wrapper = styled.div`
    background-color: ${props => props.theme.colours.background.green};
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    color: ${props => props.theme.colours.textWhite};
    padding: 20px 16px;
    border-radius: 2px;

    @media (min-width: 549px) {
        width: 100%;
        padding: 20px 0;
    }
`;

export const Title = styled.div`
    font-family: ${props => props.theme.fonts.gtWalsheimProBold};
    font-size: ${props => props.theme.fontSize.large2};
    margin-bottom: 16px;
    text-transform: uppercase;
`;

export const Body = styled.div`
    font-size: ${props => props.theme.fontSize.medium};
    font-weight: 500;
    margin-bottom: 16px;
    line-height: 22px;
`;

export const ButtonWrapper = styled.div`
    max-width: 310px;
    width: 100%;
    height: 40px;
    display: flex;
    margin: auto auto 12px;
`;

export const Terms = styled.div`
    font-weight: 400;
    font-size: ${props => props.theme.fontSize.xsmall};
    line-height: 16px;
`;

export const TermsLink = styled(Terms)`
    text-decoration: underline;
    color: ${props => props.theme.colours.textWhite};
    cursor: pointer;
`;
